import { AppConfigService } from "./app-config.service";
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { HttpService } from "./http.service";

@Injectable({ providedIn: 'root' })

export class SpectrumUserService {
  constructor(private http: HttpClient, private appConfigService: AppConfigService,
    private authenticationService: AuthenticationService,
  private httpService: HttpService) {
  }

  public GetSpectrumUserId(): Observable<any>  {
    var requestApiUrl = `${this.appConfigService.getLoadedConfig().communityApiUrl}/api/sl/users`;
    return this.httpService.get(requestApiUrl, 'text');
  }
  public CreateSpectrumUser(): Observable<any> {
    var requestApiUrl = `${this.appConfigService.getLoadedConfig().communityApiUrl}/api/sl/users`;
    
    const body = {
      'email': this.authenticationService.getMemberEmail(),
      'memberId': this.authenticationService.getMembershipId(),
    };
     let headers = new HttpHeaders({
       'Content-Type': 'application/vnd.uk.co.benenden.community-api-create-sl-user-v1+json',
     });
    return this.httpService.post(requestApiUrl, body, headers);
  }
  public UpdateSpectrumUser(): Observable<any> {
    var requestApiUrl = `${this.appConfigService.getLoadedConfig().communityApiUrl}/api/sl/users`;
    const body = {
      'email': this.authenticationService.getMemberEmail(),
      'memberId': this.authenticationService.getMembershipId(),
    };
    return this.httpService.put(requestApiUrl, body);
  }
}
